import { useEffect, useRef, useState } from "react";

/**
 * Panneau de diagnostic TEMPORAIRE pour le bug de la barre du bas (position
 * qui se decale, hauteur qui double par moments). Affiche les vraies valeurs
 * en direct plutot que de les deviner depuis une capture d'ecran :
 * - la hauteur et le padding-bottom REELS de .bottom-nav-bar (getBoundingClientRect
 *   + getComputedStyle), pas ceux qu'on suppose depuis le CSS source
 * - env(safe-area-inset-bottom) (via la sonde --debug-safe-bottom, App.css)
 * - window.innerHeight / visualViewport.height, pour voir s'ils divergent
 *   au moment du bug
 * Mis a jour en continu (rAF) pour capturer l'instant exact du glitch dans
 * un enregistrement d'ecran. Actif uniquement avec ?debug=1 dans l'URL.
 * A RETIRER une fois le vrai mecanisme identifie avec certitude.
 */
export const DebugOverlay = () => {
  const [enabled] = useState(() => {
    try {
      return new URLSearchParams(window.location.search).get("debug") === "1";
    } catch {
      return false;
    }
  });
  const [info, setInfo] = useState(null);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;

    const tick = () => {
      const nav = document.querySelector(".bottom-nav-bar");
      const rect = nav ? nav.getBoundingClientRect() : null;
      const cs = nav ? window.getComputedStyle(nav) : null;
      const rootStyle = window.getComputedStyle(document.documentElement);
      setInfo({
        t: new Date().toISOString().slice(11, 23),
        innerH: window.innerHeight,
        vvH: window.visualViewport ? Math.round(window.visualViewport.height) : "n/a",
        vvOffsetTop: window.visualViewport ? Math.round(window.visualViewport.offsetTop) : "n/a",
        docH: document.documentElement.clientHeight,
        scrollY: Math.round(window.scrollY),
        navTop: rect ? Math.round(rect.top) : "n/a",
        navBottom: rect ? Math.round(rect.bottom) : "n/a",
        navHeight: rect ? Math.round(rect.height) : "n/a",
        navPaddingBottom: cs ? cs.paddingBottom : "n/a",
        navMaxHeight: cs ? cs.maxHeight : "n/a",
        navTransform: cs ? cs.transform : "n/a",
        safeBottom: rootStyle.getPropertyValue("--debug-safe-bottom").trim() || "n/a",
      });
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [enabled]);

  if (!enabled || !info) return null;

  return (
    <div
      style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
        background: "rgba(0,0,0,0.85)", color: "#0f0",
        fontFamily: "monospace", fontSize: 10, lineHeight: 1.3,
        padding: "4px 6px", pointerEvents: "none",
        whiteSpace: "pre-wrap",
      }}
    >
      {`${info.t} | innerH:${info.innerH} vvH:${info.vvH} vvOffTop:${info.vvOffsetTop} docH:${info.docH} scrollY:${info.scrollY}
navTop:${info.navTop} navBottom:${info.navBottom} navHeight:${info.navHeight} navPB:${info.navPaddingBottom} navMaxH:${info.navMaxHeight}
safeBottom:${info.safeBottom} transform:${info.navTransform}`}
    </div>
  );
};
